<template>
	<div class="">
		<base-page-heading
			title="Shipping"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="shippingShow"
					type="submit"
					size="md"
					variant="secondary"
					@click="showModal"
				>
					<i class="fa fa-fw fa-plus" /> 	Create new
				</b-button>
			</template>
		</base-page-heading>

		<div class="row">
			<ShippingTable />
		</div>
	</div>
</template>
